<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogVisible"
    custom-class="page-dialog"
    fullscreen
    center
  >
    <template v-if="isShowDiscsList">
      <el-radio-group v-model="selectedDisk">
        <el-radio
          v-for="item in discsList"
          :key="item.name"
          :label="item.name"
          :value="item.name"
          border>{{ item.name }} drive</el-radio>
      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="toSelectedDisk">Confirm</el-button>
      </div>
    </template>
    <template v-else>
      <div class="system-labels flex-row flex-left">
      <iframe
            id="iframeContain"
            ref="iframeContain1"
            name="iframeContain"
            :src="pathUrl"
            frameborder="0"
            width="100%"
            height="100%"
          ></iframe>
      </div>
      <div class="custom-labels flex-row flex-left">
        <div class="label-title">
          <span>Selected：</span>
        </div>
        <div class="custom-content flex-column flex-middle">
          <el-tag
            :key="tag.path + tag.name"
            v-for="tag in selectedFiles"
            closable
            class="cus-tag"
            :disable-transitions="false"
            @close="handleClose(tag)">
            {{tag.name}}
          </el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="restForm()">Cancel</el-button>
        <el-button type="primary" @click="handleAction()">Sure</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>

import { getOSName } from '../../utils/common'

export default {
  name: 'LabelsDialog',
  props: {
  },
  data () {
    return {
      dialogVisible: false,
      innerVisible: false, // 内部dialog
      dialogTitle: 'Select Disk',
      pathUrl: 'http://127.0.0.1/',
      selectedFiles: [], // 选中的文件
      discsList: [], // 磁盘列表
      selectedDisk: 'C:', // 选中的磁盘
      isShowDiscsList: true, // 是否显示磁盘列表
      preSelectFilePath: '' // 之前选中的文件路径
    }
  },
  watch: {
    form () {
      console.log('formformform')
      console.log(this.form)
    }
  },
  mounted () {
    this.checkDisk()
    this.preSelectFilePath = localStorage.getItem('preSelectFilePath')
    if (this.preSelectFilePath) {
      this.pathUrl = this.preSelectFilePath
    }
  },
  methods: {
    handle (files) {
      this.selectedFiles = [...files]
      this.dialogVisible = true
    },
    sendMsg (msg) {
      // 发送消息
      this.$refs.iframeContain1.contentWindow.postMessage(msg, '*')
    },
    receivedMsg (fileInfo) {
      let prePath = ''
      if (getOSName() === 'Windows') {
        prePath = this.selectedDisk
      }
      fileInfo.file = `${prePath}${fileInfo.path}${fileInfo.name}`
      fileInfo.state = 0
      fileInfo.showMsg = ''
      let index = -1
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const element = this.selectedFiles[i]
        if (element.file === fileInfo.file) {
          index = i
          break
        }
      }
      if (index !== -1) {
        // 如果原始数组中已经包含插入字符串，则从数组中删除它
        this.selectedFiles.splice(index, 1)
      } else {
        // 如果原始数组中不包含插入字符串，则将它插入到数组中
        this.selectedFiles.push(fileInfo)
      }
    },
    receivedIframePathMsg (path) {
      localStorage.setItem('preSelectFilePath', path.href)
    },
    handleClose (tag) {
      this.selectedFiles.splice(this.selectedFiles.indexOf(tag), 1)
    },
    restForm () {
      this.form = {}
      this.dialogVisible = false
    },
    async handleAction () {
      this.$emit('updateSelectedFilesList', this.selectedFiles)
      this.dialogVisible = false
    },

    // #region *******************获取磁盘列表******************************** *//
    async getDiscs () {
      try {
        const res = await this.axios.post('/kssd/getWindowsDiscs')
        console.log(res)
        this.discsList = res.data.discs
        if (this.discsList.length === 1) { // windows只有一个磁盘自动加载
          this.selectedDisk = this.discsList[0].name
          this.initOpenDisk()
        }
      } catch (error) {
        console.log(error)
      }
    },
    async initOpenDisk () {
      try {
        const res = await this.axios.get('/kssd/initOpenDisk', {
          params: {
            disk: this.selectedDisk
          }
        })
        console.log(res)
        if (res.data.retCode >= 0) {
          this.dialogTitle = 'Select Files'
          this.isShowDiscsList = false
        } else {
          this.$message.error(res.data.retMsg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    toSelectedDisk () {
      console.log(this.selectedDisk)
      this.initOpenDisk()
    },
    async checkHasInitDisk () {
      try {
        const res = await this.axios.get('/kssd/isInitDisk', {})
        console.log(res)
        if (res.data.retCode >= 0) {
          if (res.data.hasInitDisk) {
            return true
          } else {
            return false
          }
        } else {
          this.$message.error(res.data.retMsg)
          return false
        }
      } catch (error) {
        console.log(error)
        return false
      }
    },
    async checkDisk () { // 检查读取磁盘程序是否已经加载
      const res = await this.checkHasInitDisk()
      if (res) {
        this.dialogTitle = 'Select Files'
        this.isShowDiscsList = false
      } else {
        if (getOSName() === 'Windows') {
          this.getDiscs()
        } else { // 非widows自动加载
          this.selectedDisk = ''
          this.initOpenDisk()
        }
      }
    }
    // #endregion *******************获取磁盘列表******************************** *//
  }
}
</script>

<style scoped>
  .system-labels {
    height: calc(100vh - 320px);
  }

  .label-title {
    font-size: 20px;
    font-weight: 400;
    color: #1f2f3d;
  }

  .custom-labels {
    margin-top: 20px;
  }

  .custom-content {
    margin-top: 10px;
  }

  .cus-tag {
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .select-disk-btn {
    display: block;
    margin-left: 15px;
  }

</style>



// WEBPACK FOOTER //
// src/components/common/upload_files_dialog.vue